var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCustomNotesTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5V4H11.5V5.5H4.5ZM4.5 8V6.5H11.5V8H4.5ZM7.5 16H2C1.44444 16 0.972222 15.8056 0.583333 15.4167C0.194444 15.0278 0 14.5556 0 14V11H2V0H14V7.52083C13.7222 7.53472 13.4583 7.58333 13.2083 7.66667C12.9583 7.75 12.7222 7.88194 12.5 8.0625V1.5H3.5V11H9.52083L8.02083 12.5H1.5V14C1.5 14.1417 1.54792 14.2604 1.64375 14.3562C1.73958 14.4521 1.85833 14.5 2 14.5H7.5V16ZM9 16V13.6458L13.375 9.29167C13.4758 9.18875 13.5878 9.11438 13.711 9.06854C13.8342 9.02285 13.9567 9 14.0783 9C14.211 9 14.3381 9.02431 14.4598 9.07292C14.5815 9.12153 14.6921 9.19444 14.7917 9.29167L15.7083 10.2292C15.7999 10.33 15.8713 10.442 15.9227 10.5652C15.9742 10.6884 16 10.8108 16 10.9325C16 11.0542 15.9772 11.1786 15.9315 11.3058C15.8856 11.4329 15.8113 11.5463 15.7083 11.6458L11.3542 16H9ZM10 15H10.9375L13.3333 12.6042L12.875 12.125L12.4167 11.6667L10 14.0625V15ZM12.875 12.125L12.4167 11.6667L13.3333 12.6042L12.875 12.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomNotesTemplates);
export default __webpack_public_path__ + "static/media/icon-custom-notes-templates.3fb593b76c0618b0e40684281fe1f3d7.svg";
export { ForwardRef as ReactComponent };